
<app-type-desc-marche  id="step2" [uid]="getUid()" [parentForm]="parentForm" [description]="description" [disabled]="disabled"></app-type-desc-marche>
